/**
 * Construye el payload para la hoja Consults del Excel
 * a partir de los datos ya cargados por Search (sin llamada extra al API).
 */
export function buildExcelPayloadFromAdminData(adminData) {
  if (!adminData || typeof adminData !== 'object') {
    return { DATA_EXCEL: [] }
  }

  if (Array.isArray(adminData.ALL_CONSULT_ROWS) && adminData.ALL_CONSULT_ROWS.length) {
    return { DATA_EXCEL: adminData.ALL_CONSULT_ROWS }
  }

  if (Array.isArray(adminData.DATA_EXCEL) && adminData.DATA_EXCEL.length) {
    return { DATA_EXCEL: adminData.DATA_EXCEL }
  }

  const paginated = adminData.ROWS_PAGINATE
  if (paginated && Array.isArray(paginated.data) && paginated.data.length) {
    return { DATA_EXCEL: paginated.data }
  }

  return { DATA_EXCEL: [] }
}

export function hasAdminDataForExcel(adminData) {
  return buildExcelPayloadFromAdminData(adminData).DATA_EXCEL.length > 0
}
